// extracted by mini-css-extract-plugin
export var active = "NavItem-module--active--E93NK";
export var dash = "NavItem-module--dash--JxZtb";
export var link = "NavItem-module--link--KvE6s";
export var points = "NavItem-module--points--Q7L-K";